// Formattazione valuta coerente con la valuta reale dell'addebito (Stripe).
// In modalità test con account piattaforma US la valuta può essere USD: mostriamo
// il simbolo/valuta reale invece di forzare €.
const SYMBOLS = { eur: '€', usd: '$', gbp: '£' };

export function money(amount, currency = 'eur') {
  const cur = String(currency || 'eur').toLowerCase();
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: cur.toUpperCase() }).format(n);
  } catch (_) {
    // fallback se la valuta non è riconosciuta dall'Intl
    const sym = SYMBOLS[cur] || (cur.toUpperCase() + ' ');
    return `${sym}${n.toFixed(2)}`;
  }
}

export function currencyLabel(currency = 'eur') {
  return String(currency || 'eur').toUpperCase();
}
